<template>
  <v-modal name="logout-modal">
    <h2 slot="header">{{ $t('functional.logout') }}</h2>
    <div slot="content">
      <p>
        {{ $t('functional.logoutMessage') }}
      </p>
      <v-form>
        <div slot="formButtons" type="left">
          <v-button
            type="outline-1"
            :action="modalBack"
            data-test="button-cancel-logout">
            <span>{{ $t('functional.cancel') }}</span>
          </v-button>
        </div>
        <div slot="formButtons" type="right">
          <v-button
            type="warning"
            :action="logout"
            data-test="button-confirm-logout">
            <icon name="lock" />
            <span>{{ $t('functional.logout')}}</span>
          </v-button>
        </div>
      </v-form>
    </div>
  </v-modal>
</template>

<script>
import store from 'store';
import { VButton } from '@signable/ui-kit/src/atoms/';
import { VForm, VModal } from '@signable/ui-kit/src/organisms/';

export default {
  name: 'LogoutModal',
  props: {
  },
  components: {
    VButton,
    VForm,
    VModal,
  },
  methods: {
    modalBack() {
      this.$bus.$emit('toggleModal', { name: this.$store.state.modals.history[1], active: true });
    },
    logout() {
      store.clearAll();
      this.$router.push({ name: 'Login' });
      this.$bus.$emit('closeModal');
    },
  },
};
</script>
